import { Overwrite } from "type-zoo"
import { UIAHtmlAttribute, UITypes } from "../types"

type VehicleUIAHtmlAttribute = Overwrite<UIAHtmlAttribute, { "data-id": `vehicleWidget.${string}` }>

const LicensePlateTab = {
    "data-type": UITypes.Button,
    "data-id": "vehicleWidget.licensePlateTab",
} satisfies VehicleUIAHtmlAttribute

const RegistrationNumberTab = {
    "data-type": UITypes.Button,
    "data-id": "vehicleWidget.registrationNumberTab",
} satisfies VehicleUIAHtmlAttribute

const InitialRegistrationTab = {
    "data-type": UITypes.Button,
    "data-id": "vehicleWidget.initialRegistrationTab",
} satisfies VehicleUIAHtmlAttribute

const MileageTab = {
    "data-type": UITypes.Button,
    "data-id": "vehicleWidget.mileageTab",
} satisfies VehicleUIAHtmlAttribute

const VINTab = {
    "data-type": UITypes.Button,
    "data-id": "vehicleWidget.VINTab",
} satisfies VehicleUIAHtmlAttribute

const EngineCodeTab = {
    "data-type": UITypes.Button,
    "data-id": "vehicleWidget.engineCodeTab",
} satisfies VehicleUIAHtmlAttribute

export const Vehicle = {
    LicensePlateTab,
    RegistrationNumberTab,
    InitialRegistrationTab,
    MileageTab,
    VINTab,
    EngineCodeTab,
}
